import { render, staticRenderFns } from "./PlagueMonitorings.vue?vue&type=template&id=ea887bfc&scoped=true&lang=html&"
import script from "./PlagueMonitorings.vue?vue&type=script&lang=js&"
export * from "./PlagueMonitorings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea887bfc",
  null
  
)

export default component.exports